var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.945,
    height: 34.5,
    viewBox: "0 0 99.945 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12482",
    "data-name": "Group 12482",
    transform: "translate(-808.484 84.253)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7176",
    "data-name": "Rectangle 7176",
    width: 80.695,
    height: 24.753,
    transform: "translate(809.234 -83.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1066",
    "data-name": "Line 1066",
    y2: 16.091,
    transform: "translate(817.242 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1067",
    "data-name": "Line 1067",
    y2: 16.091,
    transform: "translate(830.178 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1068",
    "data-name": "Line 1068",
    y2: 16.091,
    transform: "translate(843.113 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1069",
    "data-name": "Line 1069",
    y2: 16.091,
    transform: "translate(856.049 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1070",
    "data-name": "Line 1070",
    y2: 16.091,
    transform: "translate(868.984 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1071",
    "data-name": "Line 1071",
    y2: 16.091,
    transform: "translate(881.92 -79.195)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40576",
    "data-name": "Path 40576",
    d: "M756.679,283.5h-5v-4",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1072",
    "data-name": "Line 1072",
    x1: 3,
    transform: "translate(822.679 -54.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40577",
    "data-name": "Path 40577",
    d: "M792.679,279.5v4h-21",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40578",
    "data-name": "Path 40578",
    d: "M842.679,283.5h5v-7h-17.75",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1073",
    "data-name": "Line 1073",
    x2: 10,
    transform: "translate(886.679 -54.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1074",
    "data-name": "Line 1074",
    x2: 4,
    transform: "translate(876.679 -54.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40579",
    "data-name": "Path 40579",
    d: "M806.679,279.5v4h4",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40580",
    "data-name": "Path 40580",
    d: "M830.679,259.5h14l3,10v7",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1019",
    "data-name": "Ellipse 1019",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(816.679 -56.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1020",
    "data-name": "Ellipse 1020",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(825.679 -56.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1021",
    "data-name": "Ellipse 1021",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(870.679 -56.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1022",
    "data-name": "Ellipse 1022",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(896.679 -56.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1023",
    "data-name": "Ellipse 1023",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(880.679 -56.503)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40581",
    "data-name": "Path 40581",
    d: "M837.078,259.5v7.377l10.6,2.623",
    transform: "translate(60 -338)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter3);
export default __webpack_public_path__ + "static/media/dash-filter-3.593cc9739a54be3496043a13f90467d8.svg";
export { ForwardRef as ReactComponent };